var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar-btns-inner" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass:
          "navbar-btn bg-0 my-3 border-left-0 navbar-collapse-hidden",
        attrs: { href: "/Home/Comparison" },
      },
      [
        _c("span", { staticClass: "d-block position-relative" }, [
          _c("span", { staticClass: "navbar-btn-badge bg-secondary border" }, [
            _vm._v(_vm._s(_vm.compareItemCount)),
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "mx-auto mb-1",
            attrs: { "data-feather": "repeat" },
          }),
          _vm._v("Сравнение\n\t\t"),
        ]),
      ]
    ),
    _vm._v(" "),
    !_vm.hideSearchButton
      ? _c(
          "a",
          {
            staticClass: "navbar-btn",
            attrs: { href: "#offcanvas-search", "data-toggle": "offcanvas" },
          },
          [
            _c("i", {
              staticClass: "mx-auto mb-1",
              attrs: { "data-feather": "search" },
            }),
            _vm._v("Поиск\n\t"),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "navbar-btn",
        class: { "bg-0": _vm.hideSearchButton, "my-3": _vm.hideSearchButton },
        attrs: { href: "#offcanvas-profile", "data-toggle": "offcanvas" },
      },
      [
        _vm.userLogged
          ? _c("span", [
              _c("i", { staticClass: "mx-auto mb-1 fa fa-user-o" }),
              _c("br"),
              _vm._v(" "),
              _c("span", { staticClass: "d-none d-sm-inline" }, [
                _vm._v("Мой профиль"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "d-inline d-sm-none" }, [_vm._v("Я")]),
            ])
          : _c("span", [
              _c("i", { staticClass: "mx-auto mb-1 fa fa-sign-in" }),
              _c("br"),
              _vm._v("Вход\n\t\t"),
            ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "navbar-btn",
        class: { "bg-0": _vm.hideSearchButton, "my-3": _vm.hideSearchButton },
        attrs: { href: "#offcanvas-cart", "data-toggle": "offcanvas" },
      },
      [
        _c("span", { staticClass: "d-block position-relative" }, [
          _c(
            "span",
            { staticClass: "navbar-btn-badge bg-primary text-light" },
            [_vm._v(_vm._s(_vm.itemCount))]
          ),
          _vm._v(" "),
          _c("i", {
            staticClass: "mx-auto mb-1",
            attrs: { "data-feather": "shopping-cart" },
          }),
          _vm._v("₽ " + _vm._s(_vm.totalSum) + "\n\t\t"),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "navbar-toggler navbar-btn collapsed",
        attrs: { "data-toggle": "collapse", "data-target": "#menu" },
      },
      [
        _c("i", {
          staticClass: "mx-auto mb-1",
          attrs: { "data-feather": "menu" },
        }),
        _vm._v("Меню"),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }